<!-- =========================================================================================
  File Name: Todo.vue
  Description: Todo Application to keep you ahead of time
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div :id="divId" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden todo-app">
        <vs-sidebar class="items-no-padding" :parent="parentDiv" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <todo-add-new  
              @submit="onAdd" 
              :allowAdd="allowAdd"
              :addText="addText" 
              :displayDueDate="displayDueDate"
              :displayStatus="displayStatus" />
            <component :is="scrollbarTag" class="todo-scroll-area" :settings="settings" :key="$vs.rtl">
                <todo-filters
                   @closeSidebar="toggleTodoSidebar" 
                   @filterChange="onFilterChange"
                  :displayStatus="displayStatus"
                  :displayFilters="displayFilters"
                    ></todo-filters>
            </component>

        </vs-sidebar>
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">

                <!-- TOGGLE SIDEBAR BUTTON -->
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleTodoSidebar(true)" />

                <!-- SEARCH BAR -->
                <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" :placeholder="$t('SearchPlaceholder')" v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
            </div>

            <!-- TODO LIST -->
            <component :is="scrollbarTag" class="todo-content-scroll-area" :settings="settings" ref="taskListPS" :key="$vs.rtl">

                <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
                    <li
                      class="cursor-pointer todo_todo-item"
                      v-for="(task, index) in filteredTasks"
                      :key="String(currFilter) + String(task.uniqueId)"
                      :style="[{transitionDelay: (index * 0.1) + 's'}]">

                      <todo-task 
                        @viewHistory="onViewHistory" 
                        @completeTask="onEdit" 
                        @deleteTask="onDelete" 
                        :taskId="task.uniqueId" 
                        :task="task" 
                        :displayDueDate="displayDueDate"
                        :displayStatus="displayStatus"
                        :allowDelete="allowDelete"
                        :allowComplete="allowComplete"
                        @showDisplayPrompt="showDisplayPrompt($event)" 
                        :key="String(task.title) + String(task.desc)" />
                    </li>
                </transition-group>
            </component>
            <!-- /TODO LIST -->

        </div>

        <!-- EDIT TODO DIALOG -->
        <todo-edit 
          v-if="displayPrompt"
          :editText="editText" 
          :canEditTitle="canEditTitle"
          :allowComplete="allowComplete"
          @submit="onEdit"
          @delete="onDelete" 
          :displayPrompt="displayPrompt"
          :displayDueDate="displayDueDate"
          :displayStatus="displayStatus"  
          :taskId="taskIdToEdit" 
          :task="taskToEdit" 
          @hideDisplayPrompt="hidePrompt" 
          ></todo-edit>
    </div>
</template>

<script>
import TodoAddNew          from './TodoAddNew.vue'
import TodoTask            from './TodoTask.vue'
import TodoFilters         from './TodoFilters.vue'
import TodoEdit            from './TodoEdit.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    tasks: {
      type: Array,
      default: () => {}
    },
    displayDueDate : {
      type: Boolean,
      default: false
    },
    displayStatus : {
      type: Boolean,
      default: true
    },
    displayFilters : {
      type: Boolean,
      default: true
    },
    addText : {
      type: String,
      default : "Add"
    },
    editText : {
      type: String,
      default : "Edit"
    },
    divId : {
      type: String,
      default : "todo-app"
    },
    allowDelete : {
      type:Boolean,
      default : true
    },
    allowComplete : {
      type:Boolean,
      default : true
    },
    allowAdd : {
      type:Boolean,
      default : true
    },
    canEditTitle :  {
      type:Boolean,
      default : true
    }
  },
  data () {
    return {
      currFilter : 'all',
      clickNotClose : true,
      displayPrompt : false,
      taskIdToEdit : 0,
      taskToEdit : null,
      isSidebarActive : true,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      todoSearchQuery : ""
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    parentDiv() {
      return "#" + this.$props.divId;
    },
    filteredTasks() {
      return this.tasks.filter((task) => {
        let isItemOfCurrentFilter = false
        if ((this.currFilter === 'all' && !task.isTrashed)
              || (this.currFilter === 'completed' && !task.isTrashed && task.isCompleted)
              || (this.currFilter === 'trashed' && task.isTrashed)
              || (task.status === this.currFilter)) { 
          isItemOfCurrentFilter = true 
        }

        return isItemOfCurrentFilter && (task.name.toLowerCase().includes(this.todoSearchQuery.toLowerCase()) || task.desc.toLowerCase().includes(this.todoSearchQuery.toLowerCase()));
      });
    },
    searchQuery:   {
      get ()        { return this.todoSearchQuery        },
      set (val)     { this.todoSearchQuery = val }
    },
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag
    },
    windowWidth ()  { return this.$store.state.windowWidth                 }
  },
  methods: {
    showDisplayPrompt (itemId) {
      this.taskIdToEdit  = itemId
      this.taskToEdit = this.tasks.find(t => t.uniqueId === itemId);
      this.displayPrompt = true
    },
    onViewHistory(historyData) {
      this.$emit("viewHistory", historyData);
    },
    hidePrompt () {
      this.displayPrompt = false
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isSidebarActive = this.clickNotClose = false
      } else {
        this.isSidebarActive = this.clickNotClose = true
      }
    },
    toggleTodoSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarActive = value
    },
    onFilterChange(filter) {
      this.currFilter = filter;
    },
    onAdd(todo) {
      this.$emit("add", todo);
    },
    onEdit(todo) {
      this.$emit("edit", todo);
    },
    onDelete(todo) {
      this.$emit("delete", todo);
    }
  },
  components: {
    TodoAddNew,
    TodoTask,
    TodoFilters,
    TodoEdit,
    VuePerfectScrollbar
  },
  created () {
    this.setSidebarWidth()
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
</style>
